import React, { FunctionComponent } from 'react'

import { GlobalScripts } from '@common/components'
import { LMI_MA_SCRIPT } from '@common/constants'
import { useFavicon } from '@common/hooks/useFavicon'
import { useSelector } from 'react-redux'
import { BuyRoutes } from './Routes'
import { ConnectedBuyTrackingProvider } from './connectedComponents'
import { getProductSettingsData } from './state/selectors'

const App: FunctionComponent = () => {
    // Can't use useRoute() here to get the pathProduct because this file is loaded before the router
    const productSettings = useSelector(getProductSettingsData)
    useFavicon(productSettings?.favicon || '')

    return (
        <>
            <GlobalScripts
                analyticsProductKey={productSettings.analyticsContainerID}
                lmiMaScriptUrl={LMI_MA_SCRIPT.URL}
                enableChatBot={productSettings.enableChatBot}
            />
            {/* <FeatureFlagProvider siteType={productConfig!.siteType}> // Feature flags are deprecated */}
            <ConnectedBuyTrackingProvider>
                <BuyRoutes />
            </ConnectedBuyTrackingProvider>
            {/* </FeatureFlagProvider> */}
        </>
    )
}

export default App
